import React from 'react';
import styled from 'styled-components';
import { Section } from 'components/layout/Section';
import { Form } from 'modules/footer/components/Form';
import { Header } from 'components/header';
import { BodyText } from 'components/typography/bodyText';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';
import media from 'constants/styles/media';

const SContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const SWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 36px;
`;

const SSWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 716px;
    @media (max-width: ${media.tablet}) {
        max-width: none;
    }
`;

const SImageWrapper = styled.div`
    max-width: 516px;
    max-height: 340px;
    @media (max-width: ${media.tablet}) {
        display: none;
    }
`;

export const ContactSection = () => {
    const { t } = useTranslation();
    return (
        <Section>
            <SContainer>
                <SWrapper>
                    <SSWrapper>
                        <Header text={t('contact.header')} />
                        <BodyText>{t('contact.description')}</BodyText>
                        <Form />
                    </SSWrapper>
                    <SImageWrapper>
                        <StaticImage
                            src="../../images/engineer.png"
                            layout="constrained"
                            quality={95}
                            formats={['auto', 'webp', 'avif']}
                            alt="Digitalization support"
                            style={{
                                width: '100%',
                                height: 'auto',
                            }}
                        />
                    </SImageWrapper>
                </SWrapper>
            </SContainer>
        </Section>
    );
};
